import * as Redux from 'redux';
import { IActionCreator } from '../../../../common/interfaces/IActionCreator'
import { Keys } from './types';
import { invokeApi } from '../../../../common/networking/invoker';
import { ActivitySchedule, ActivityState } from '../../../../model/activities';
import { contact } from '../../../../model/contact';

export interface IActions {
    loadAllActivities: () => any;
    getSchedules: (from: Date, to: Date, state: ActivityState) => any;
    saveSchedule: (activity: ActivitySchedule, updateSimilar: boolean) => void;
    deleteSchedule: (id: string) => void;
    createSchedule: (s: ActivitySchedule) => void;
    addReservation: (contact: contact, schedule: ActivitySchedule) => any;
    removeReservation: (scheduleId: string, id: string) => any;
}

export const actionCreator: IActionCreator<IActions> = (dispatch: Redux.Dispatch<any>): IActions => {
    return {
        addReservation: (c, s) => {
            const path = `/api/Activities/Schedules/${s._id}/reservations`;
            return dispatch({
                type: Keys.ADDRESERVATION,
                payload: invokeApi({
                    path: path,
                    body: c.sub,
                    method: 'POST',
                    responseType: 'json'
                })
            })
        },
        removeReservation: (scheduleId: string, id: string) => {
            const path = `/api/Activities/Schedules/${scheduleId}/reservations/${id}`;
            return dispatch({
                type: Keys.REMOVERESERVATION,
                payload: invokeApi({
                    path: path,
                    method: 'DELETE',
                    responseType: 'json'
                })
            })
        },
        getSchedules: (from, to, state) => {
            const path = `/api/Activities/Schedules?from=${from.toISOString()}&to=${to.toISOString()}` + (state !== undefined ? `&state=${state}` : '');
            return dispatch({
                type: Keys.GETSCHEDULES,
                payload: invokeApi({
                    path: path,
                    method: 'GET',
                    responseType: 'json'
                })
            })
        },
        saveSchedule: (s: ActivitySchedule, updateSimilar: boolean = false) => {
            // [HttpPut("{id}/updateallsimilar")]
            // public IActionResult UpdateAllSimilarSchedule(string id, [FromBody] ActivitySchedule schedule)
            console.log("saveSchedule Activity Reservations", s, updateSimilar);
            dispatch({
                type: Keys.SAVESCHEDULE,
                payload: invokeApi({
                    path: '/api/Activities/Schedules/' + s._id + (updateSimilar ? '/updateallsimilar' : ''),
                    method: 'PUT',
                    body: s,
                    responseType: 'json'
                })
            })
        },
        createSchedule: (s: ActivitySchedule) => {
            dispatch({
                type: Keys.CREATESCHEDULE,
                payload: invokeApi({
                    path: '/api/Activities/Schedules',
                    method: 'POST',
                    body: s,
                    responseType: 'json'
                })
            })
        },
        deleteSchedule: (id: string) => {
            dispatch({
                type: Keys.DELETESCHEDULE,
                payload: invokeApi({
                    path: '/api/Activities/Schedules/' + id,
                    method: 'DELETE',
                }),
                meta: id
            })
        },
        loadAllActivities: () => {
            dispatch({
                type: Keys.LOADACTIVITIES,
                payload: invokeApi({
                    path: '/api/Activities',
                    method: 'GET',
                    responseType: 'json'
                })
            })
        }
    }
}